import { useFormikContext } from "formik";
import { useEffect, useRef } from "react";

// Este component guarda automaticamente los valores del formulario al desmontarlos.
// No se deberia usar excepto para casos como el breadcrumb para volver atras y conservar los valores, ya que no revisa validaciones. 

/**
 * 
 * @param {ref} saveOnUnmountRef Debe ser un ref a un booleano que indica si guardar o no.
 * @param {function} handleSave Debe ser una funcion creada por useCallback para evitar bucles infinitos
 * @returns 
 */
const FormikAutoSaveOnUnmount = ({ saveOnUnmountRef, handleSave }) => {
  const { values } = useFormikContext();
  const latestValuesRef = useRef(values);

  /* 
  Necesitamos esta referencia para evitar usar values como depencendia del useEffect que guarda el formulario. Y asi evitar un bucle infinito de guardado sin desmontar
  */
  useEffect(() => {
    latestValuesRef.current = values;
  }, [values]);

  useEffect(() => {
    return () => {
      if (saveOnUnmountRef?.current) {
        handleSave(latestValuesRef.current);
      }
    }
  }, [handleSave]);
  return null;

};

export default FormikAutoSaveOnUnmount;